import type { CreatorsControllerTopCreatorsParams } from "@/lib/lutely-api/gen/dtos";
import { createInfiniteQueryHook } from "../create-infinite-query-hook";
import {
  creatorsControllerTopCreators,
  getCreatorsControllerTopCreatorsQueryKey,
} from "../gen/creators/creators";

type UseTopCreatorsInfiniteQueryParams = Omit<
  CreatorsControllerTopCreatorsParams,
  "pageNumber"
>;

// Infer the data return type from the generated fetcher
type TopCreatorsPage = Awaited<
  ReturnType<typeof creatorsControllerTopCreators>
>;

export const useTopCreatorsInfiniteQuery = createInfiniteQueryHook<
  UseTopCreatorsInfiniteQueryParams,
  TopCreatorsPage
>({
  fetchPage: creatorsControllerTopCreators,
  getQueryKey: getCreatorsControllerTopCreatorsQueryKey,
});
